import React from 'react';
import { useSelector } from 'react-redux';
import ColumnFilter from '../../../column-filter/ColumnFilter';

function AudienceCorrelationFilters({ selectedFilters, onApply, selectedAudience }) {
  const filterColumns = useSelector((state) => state.resonance.filterColumns);

  const filteredAudienceColumns = filterColumns.filter(({ header }) => header !== selectedAudience);

  return (
    <>
      {(filteredAudienceColumns ?? []).map(({ type, header, audiences }) => (
        <ColumnFilter
          key={type}
          label={header}
          options={audiences}
          selectedOptions={selectedFilters}
          onApply={onApply}
        />
      ))}
    </>
  );
}

export default AudienceCorrelationFilters;
